import { useCallback, useEffect, useState } from "react";

import Notification from "../modules/Notifications";

import api from "../service/api";

const useAccess = () => {
    const [accesses, setAccesses] = useState<any[]>([]);

    const show = useCallback(() => {
        const show = async () => {
            try {
                const response = await api.get("/users-permissions/roles");

                const serializedRoles = response.data.roles.map((role) => ({
                    value: role.id,
                    label: role.name,
                }));

                setAccesses(serializedRoles);
            } catch (err) {
                Notification("error", "Listar acessos falhou");
            }
        };

        show();
    }, []);

    useEffect(() => {
        show();
    }, [show]);

    return { accesses };
};

export default useAccess;
